import styled from 'styled-components';
import { getToken } from '@optimus-web/common';
import { getIconColor } from '../Icon/getIconStyles';
import { SupplementaryIconVariant } from './types';

export const SupplementaryIconElement = styled.span<{ variant: SupplementaryIconVariant }>`
    background-color: ${getIconColor};
    width: 64px;
    height: 64px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: ${getToken('borderRadiusRound')};
`;
